import Layout from '@/layout/index.vue';
import { categoriesSubMenu } from './subMenus/category-sub-menu';
import { rangesSubMenu } from './subMenus/range-sub-menu';
import { schemesCategoriesSubMenu } from './subMenus/schemes-categories-sub-menu';
const productRouter = {
  path: '/product',
  component: Layout,
  redirect: 'noredirect',
  name: 'productManagement.title',
  meta: {
    roles: ['Super Admin', 'Admin', 'Unit Manager', 'Invoice Manager', 'Read Only', 'Regional Manager', 'Zonal Manager', 'Branch Manager', 'Order Manager', 'Payment Manager', 'Agent', 'Branch Manager', 'Account Manager'],
    title: 'productManagement.title',
    icon: 'almond'
  },
  children: [{
    path: '/attribute/list',
    component: () => import('@/views/attribute/list.vue'),
    name: 'productManagement.attribute.title',
    meta: {
      title: 'productManagement.attribute.title',
      roles: ['Super Admin', 'Admin'],
      noCache: true,
      icon: 'sack'
    }
  }, {
    path: '/attribute/add',
    component: () => import('@/views/attribute/manage.vue'),
    name: 'productManagement.attribute.add',
    props: {
      isEdit: false
    },
    meta: {
      title: 'productManagement.attribute.add',
      noCache: true,
      hidden: true
    }
  }, {
    path: '/attribute/edit/:id(\\d+)',
    component: () => import('@/views/attribute/manage.vue'),
    name: 'productManagement.attribute.edit',
    props: {
      isEdit: true
    },
    meta: {
      title: 'productManagement.attribute.edit',
      noCache: true,
      hidden: true
    }
  }, {
    path: '/attribute-value/list/:id',
    component: () => import('@/views/attribute-value/list.vue'),
    name: 'Attribute Value',
    meta: {
      title: 'productManagement.attributevalue.title',
      roles: ['Super Admin', 'Admin', 'Regional Manager', 'Zonal Manager'],
      noCache: true,
      activeMenu: '/attribute/list',
      hidden: true
    }
  }, {
    path: '/attribute-value/add/:id(\\d+)',
    component: () => import('@/views/attribute-value/manage.vue'),
    name: 'Manage Attribute Value',
    props: {
      isEdit: false
    },
    meta: {
      title: 'productManagement.attributevalue.manage',
      noCache: true,
      hidden: true
    }
  }, {
    path: '/attribute-value/edit/:id(\\d+)',
    component: () => import('@/views/attribute-value/manage.vue'),
    name: 'productManagement.attributevalue.manage',
    props: {
      isEdit: true
    },
    meta: {
      title: 'productManagement.attributevalue.manage',
      noCache: true,
      hidden: true
    }
  }, ...rangesSubMenu, ...categoriesSubMenu, ...schemesCategoriesSubMenu, {
    path: '/product/list',
    component: () => import('@/views/products/list.vue'),
    name: 'productManagement.product.title',
    meta: {
      title: 'productManagement.product.title',
      icon: 'almond',
      noCache: true
    }
  }, {
    path: '/product/add',
    component: () => import('@/views/products/manage.vue'),
    name: 'productManagement.product.manage',
    props: {
      isEdit: false
    },
    meta: {
      title: 'productManagement.product.manage',
      roles: ['Super Admin', 'Admin'],
      noCache: true,
      hidden: true
    }
  }, {
    path: '/product/edit/:id(\\d+)',
    component: () => import('@/views/products/manage.vue'),
    name: 'productManagement.product.manage',
    props: {
      isEdit: true
    },
    meta: {
      title: 'productManagement.product.manage',
      roles: ['Super Admin', 'Admin'],
      noCache: true,
      hidden: true
    }
  }, {
    path: '/product/import',
    component: () => import('@/views/products/import.vue'),
    name: 'productManagement.product.import',
    props: {
      isEdit: false
    },
    meta: {
      title: 'productManagement.product.import',
      noCache: true,
      hidden: true
    }
  }, {
    path: '/product/import-images',
    component: () => import('@/views/products/images.vue'),
    name: 'productManagement.product.importImages',
    props: {
      isEdit: false
    },
    meta: {
      title: 'productManagement.product.importImages',
      noCache: true,
      hidden: true
    }
  }]
};
export default productRouter;